import { createLogger, createStore } from "vuex";

import { container } from "../container";
import accounting from "./modules/accounting/accounting.module";
import auth from "./modules/auth/auth.module";
import customer from "./modules/customer/customer.module";
import global from "./modules/global/global.module";

const plugins = container.debug ? [createLogger({})] : [];

export const store = {
  modules: {
    accounting,
    auth,
    customer,
    global,
  },
};

export const storeInstance = createStore({
  plugins,
  modules: store.modules,
});
